function getLocalStorageState(){
  const stateString = localStorage.getItem('app-nav');
  if(stateString){
    // console.log(`parsing state ${stateString}`)
    try{
      return JSON.parse(stateString);
    }
    catch(err) {
      localStorage.setItem('app-nav', null);
    }
  }
  else{
    null
  }
}

const state = {
  view: {
    drawer: getLocalStorageState() ? getLocalStorageState().drawer:true,
    center: getLocalStorageState() ? getLocalStorageState().center:null,
    dialog: false,
  },
  loading: false
}

const mutations = {
  setCenter(state, center) {
    state.view.center = center;
    localStorage.setItem('app-nav', JSON.stringify(state.view));
  },
  clearCenter(state) {
    state.view.center = null;
    localStorage.setItem('app-nav', JSON.stringify(state.view));
  },
  setViewDrawer(state, drawer) {
    state.view.drawer = drawer;
    localStorage.setItem('app-nav', JSON.stringify(state.view));
  },
  setViewDialog(state, dialog) {
    state.view.dialog = dialog
  },
  setAppLoading() {
    // console.log('setting state app is loading')
    state.loading = true;
  },
  setAppDoneLoading() {
    // console.log('setting state app stopped loading')
    state.loading = false;
  }
}

const actions = {
  setCenter({ commit }, center) {
    commit('setCenter', center);
  },
  clearCenter({ commit }) {
    commit('clearCenter');
  },
  toggleDrawer({ commit, state }) {
    commit('setViewDrawer', !state.view.drawer);
  },
  hideDrawer({ commit }) {
    commit('setViewDrawer', false);
  },
  showDrawer({ commit }) {
    commit('setViewDrawer', true);
  },
  showDialog({ commit }){
    commit('setViewDialog', true)
  },
  hideDialog({ commit }){
    commit('setViewDialog', false)
  },
  appLoading({ commit }){
    commit('setAppLoading');
  },
  stopAppLoading({commit}){
    commit('setAppDoneLoading');
  }
}

const getters = {
	navState: (state) => {
		return state.view;
  },
	globalCenter: (state) => {
		return state.view.center;
  },
  isAppLoading: (state) => {
    return state.loading;
  }
}

export default {
	state,
	mutations,
  actions,
  getters
}

